$(function () {
    $('body').removeClass('preload')
    $('input[type=text]').attr('autocomplete', 'off').attr('spellcheck', 'off')
    $('[data-behaviour=toggle-menu]').click(function (e) {
        e.preventDefault();
        var $menu = $('.header-menu');
        if ($menu.is(':visible')) {
            $menu.slideUp();
        } else {
            $menu.slideDown();
        }
    })
    $('.header-menu').on('click', 'a', function (e) {
        $('.header-menu').slideUp();
    });
    $('a[href^="#"]').on('click', function (e) {
        e.preventDefault();
        var target = $(e.target).closest('a').attr('href').substr(1);
        var top = $('a[name="' + target + '"]').offset().top;
        $('html, body').animate({scrollTop: top + 'px'});
    });
    $('[data-timer]').each(function () {
        var $this = $(this);
        var timer = $this.data('timer');
        var total = $this.data('total');
        $this.timer({
            duration: timer,
            total: total,
            unit: 's'
        });
    });
    $('[data-youtube]').each(function () {
        var $this = $(this);
        var height = $(this).height();
        var width = Math.ceil(height / 9 * 16);
        var youtube_id = $this.data('youtube');
        $this.append('<iframe type="text/html" src="https://www.youtube.com/embed/' + youtube_id + '?controls=0&showinfo=0&autoplay=1&autohide=1&rel=0&mute=1&loop=1&playlist=' + youtube_id + '" frameborder="0" style="width: ' + width.toString() + 'px"></iframe>');
    })
    $('[data-behaviour=search]').on('click', function (e) {
        if ($(window).width() >= 768) {
            e.preventDefault();
            var $search = $('.search-box');
            if ($search.is(':visible')) {
                $search.fadeOut();
            } else {
                $search.fadeIn();
                setTimeout(function () {
                    $search.find('input[type=text]').focus();
                }, 500);
            }
        }
    });
    $('.header-toolbar').affix({
      offset: {
        top: 0
      }
    });
    $.fancybox.defaults.loop = true
    //
    if ($('.autonumeric-it').length) {
        new AutoNumeric('.autonumeric-it', {
            decimalCharacter : ',',
            digitGroupSeparator : '.',
            decimalPlaces: 0
        });
    }
    if ($('.autonumeric-en').length) {
        new AutoNumeric('.autonumeric-en', {
            decimalCharacter : '.',
            digitGroupSeparator : ',',
            decimalPlaces: 0
        });
    }
    //
    $('[data-ride="carousel"]').carousel().swipeCarousel({
        sensitivity: 'medium'
    });

    var btn = $('#go_to_top');
    var btn2 = $('.floating-contact');

    $(window).scroll(function() {
      if ($(window).scrollTop() > 300) {
        btn.addClass('show');
      } else {
        btn.removeClass('show');
      }

      if ($(window).scrollTop() > 300 && $(window).scrollTop() <= ($(document).height() - 1000)) {
        btn2.addClass('show');
      } else {
        btn2.removeClass('show');
      }
    });

    btn.on('click', function(e) {
      e.preventDefault();
      $('html, body').animate({scrollTop:0}, '300');
    });

    $('[data-toggle="tooltip"]').tooltip();
})
